// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'translate';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m14.419 1.031-2.657 1.594 1.594 2.656' />
    <path d='M16.969 6.301a4.767 4.767 0 0 0-4.874-3.13M3.581 16.969l2.656-1.594-1.593-2.656' />
    <path d='M1.031 11.699a4.767 4.767 0 0 0 4.874 3.13M2.094 1.031h6.375s1.062 0 1.062 1.063v6.375s0 1.062-1.062 1.062H2.094s-1.063 0-1.063-1.062V2.094s0-1.063 1.063-1.063zm9.562 7.438h4.25A1.063 1.063 0 0 1 16.97 9.53v6.375a1.063 1.063 0 0 1-1.063 1.063H9.531a1.063 1.063 0 0 1-1.062-1.063v-4.25m3.011 1.595h2.478M5.281 3.156v1.062m-2.125.001h4.25' />
    <path d='M6.344 4.219S5.28 7.406 3.156 7.406' />
    <path d='M5.281 6.167A2.776 2.776 0 0 0 7.406 7.39m4.074 7.454V12.01a1.24 1.24 0 0 1 2.478 0v2.834' />
  </g>
);

export const viewBox = '0 0 18 18';
